export type ISignupScreenState =
  | "signup"
  | "verify"
  | "loading"
  | "verifying"
  | "verified"
  | "account-details"
  | "onboarding"
  | "not-verified";

export const SIGNUP_SCREEN: { [key: string]: ISignupScreenState } = {
  SIGNUP: "signup",
  VERIFY: "verify",
  LOADING: "loading",
  VERIFYING: "verifying",
  ACCOUNT_DETAILS: "account-details",
  VERIFIED: "verified",
  ONBOARDING: "onboarding",
  NOTVERIFIED: "not-verified",
};
